export function imagesAreConsideredSufficient(
  images: string[] | undefined
): boolean {
  return !!images?.length;
}
